// For featured game on home page:
export const GAME_NAME = "SUPER BOWL LX";
export const GAME_KEY = "nfl_2025";
export const AWAY_TEAM = "SEA";
export const HOME_TEAM = "NE";



// WEBPACK FOOTER //
// ./src/gameInfo.js